import { Component, computed, inject, input, resource } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { Rolle } from '../../roller/rolle.model';
import { BrugerRolle } from './bruger-rolle.model';
import { BrugerDetailService } from '../bruger-detail/bruger-detail.service';
import { TooltipModule } from 'primeng/tooltip';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { appConfig } from '@core/app-config';
import { firstValueFrom } from 'rxjs';
import { ScrollPanel } from 'primeng/scrollpanel';
import { RolleDatasource } from '@features/roller/rolle.datasource';
import { BrugerRolleApi } from '@features/brugere/bruger-roller/bruger-rolle.api';

@Component({
  selector: 'app-bruger-roller',
  imports: [CheckboxModule, FormsModule, TooltipModule, DatePipe, ScrollPanel],
  templateUrl: './bruger-roller.component.html',
  styleUrl: './bruger-roller.component.css',
})
export class BrugerRollerComponent {
  httpClient = inject(HttpClient);
  brugerId = input.required<number>();
  isLetpension = input.required<boolean>();
  brugerDetailService = inject(BrugerDetailService);
  brugerRolleApi = inject(BrugerRolleApi);
  rolleDatasource = inject(RolleDatasource);
  brugerRoller = computed(() => {
    const apiResponse = this.data.value();
    if (apiResponse) {
      return apiResponse.data;
    } else {
      return [];
    }
  });
  roller = computed(() => {
    const apiResponse = this.rolleDatasource.data.value();
    if (apiResponse) {
      return apiResponse.data;
    } else {
      return [];
    }
  });

  data = resource({
    params: () => this.brugerId(),
    loader: async ({ params, abortSignal }) => {
      return await this.brugerRolleApi.getList(
        {
          filter: JSON.stringify({
            brugerId: params,
          }),
        },
        abortSignal
      );
    },
  });

  rolleData = computed(() => {
    const _rolleData: RolleData[] = [];
    this.roller().forEach(rolle => {
      const brCheck = this.brugerRoller().filter(
        brugerRolle => brugerRolle.rolleId === rolle.id
      );
      if (brCheck.length > 0) {
        const brugerRolle = brCheck[0];
        _rolleData.push({
          ...rolle,
          brugerRolle: brugerRolle,
          checked: !!brugerRolle,
          sendVelkomstMail: false,
        });
      } else {
        _rolleData.push({ ...rolle, checked: false, sendVelkomstMail: false });
      }
    });
    return _rolleData;
  });

  grant(r: RolleData) {
    if (r.id) {
      if (r.checked) {
        if (this.brugerDetailService.changes()[r.id]?.action === 'add') {
          delete this.brugerDetailService.changes()[r.id];
        } else {
          if (r.brugerRolle) {
            this.brugerDetailService.changes()[r.id] = {
              action: 'remove',
              id: r.brugerRolle.id,
            };
          }
        }
      } else {
        if (this.brugerDetailService.changes()[r.id]?.action === 'remove') {
          delete this.brugerDetailService.changes()[r.id];
        } else {
          this.brugerDetailService.changes()[r.id] = {
            action: 'add',
            rolleId: r.id,
          };
        }
      }
    }
  }

  async sendMail(brugerRolle: BrugerRolle) {
    try {
      brugerRolle.loading = true;
      const url = `${appConfig.apiRoot}/api/BrugerRoller/sendmail/${brugerRolle.id}`;
      const source = this.httpClient.post(url, {});
      await firstValueFrom(source);
      brugerRolle.velkomstmailAfsendt = new Date();
      brugerRolle.loading = false;
    } catch (error) {
      console.error(error);
    }
  }

  bestilVelkomstMail(r: RolleData) {
    const changes = this.brugerDetailService.changes();
    const change = changes[r.id];
    if (change.action === 'add') {
      change.sendVelkomstmail = !r.sendVelkomstMail;
    }
    this.brugerDetailService.changes.set(changes);
  }
}

interface RolleData extends Rolle {
  checked: boolean;
  sendVelkomstMail: boolean;
  brugerRolle?: BrugerRolle;
}
